export type Environment =
  | "development"
  | "sandbox"
  | "engineering"
  | "production"
  | "review-app";

export const getEnv = (url: string): Environment | undefined => {
  try {
    const parsedUrl = new URL(url);
    const host = parsedUrl.host;

    if (host.includes("localhost")) {
      return "development";
    }

    if (host.includes("sandbox")) {
      return "sandbox";
    }

    if (host.includes("engineering")) {
      return "engineering";
    }

    if (host.includes("dev-bolo")) {
      return "engineering";
    }

    if (host.includes("review-app")) {
      return "review-app";
    }

    if (host.includes("hellocarbo")) {
      return "production";
    }
  } catch {
    return;
  }
};
